import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface CountdownRedirectProps {
  seconds: number;
  redirectPath: string;
  skipButtonText?: string;
  message?: string;
}

export function CountdownRedirect({
  seconds,
  redirectPath,
  skipButtonText = 'Skip and Go Now',
  message,
}: CountdownRedirectProps) {
  const [countdown, setCountdown] = useState(seconds);
  const navigate = useNavigate();

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      navigate(redirectPath);
    }
  }, [countdown, navigate, redirectPath]);

  const handleSkip = () => {
    navigate(redirectPath);
  };

  const defaultMessage = `Redirecting in ${countdown} second${countdown !== 1 ? 's' : ''}...`;

  return (
    <>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <p className="text-blue-800 font-medium">
          {message || defaultMessage}
        </p>
      </div>
      <button
        onClick={handleSkip}
        className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-blue-700 transition-colors"
      >
        {skipButtonText}
      </button>
    </>
  );
}
